import React, { useState } from "react";
import { motion } from "framer-motion";
import Popup from "../components/Popup";
import WebinarFormPopup from "../components/WebinarFormPopup";
import { FaVideo, FaTools, FaInfinity, FaBriefcase } from "react-icons/fa";
import CoursetFreeTrial from "../components/CoursetFreeTrial";
import OffersBanner from "../components/OffersBanner";
import Pricing from "../components/Pricing";
import WhatMakes from "../components/WhatMakes";
import CourseClassesSection from "../components/CourseClassesSection";
import OffersStories from "../components/OffersStories";
import OffersFreeTrial from "../components/OffersFreeTrial";
import StepsSection from "../components/StepsSection";

function Offers() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupContent, setPopupContent] = useState(null);

  const openPopup = (content) => {
    setPopupContent(content);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setPopupContent(null);
  };

  const courseData = {
    highlights: [
      { icon: <FaVideo />, text: "350+ Live sessions" },
      { icon: <FaTools />, text: "15+ Industry Projects" },
      { icon: <FaInfinity />, text: "Lifetime accessibility" },
      { icon: <FaBriefcase />, text: "Live project experience" },
    ],
    title: "Basic Level: Spoken English Course Content",
    description:
      "This course is designed for individuals who can read and write English but lack confidence and fluency in speaking. The focus is on practical communication skills and real-world application.",
    // price: "120,000",
    emi: "5,900",
    applyLink: "#apply",

    batchDate: { day: "19", month: "AUG", batch: "Morning" },
    batchName: "Next Advanced Level: Spoken English",
    batchDays: "Sat - Sun",
    batchTime: "09:00 am - 12:00 pm",
    batchSeat: "Available",
    batchVenue: "Virtual Hall",
    enrollLink: "#enroll",
  };

  return (
    <>
      {/* Banner Animation */}
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <OffersBanner />
      </motion.div>

      {/* Staggered Sections */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        transition={{ staggerChildren: 0.25 }}
        variants={{
          hidden: { opacity: 0, y: 50 },
          visible: { opacity: 1, y: 0 },
        }}
      >
        <motion.div variants={{ hidden: { opacity: 0, y: 40 }, visible: { opacity: 1, y: 0 } }}>
          <Pricing />
        </motion.div>

        <motion.div variants={{ hidden: { opacity: 0, y: 40 }, visible: { opacity: 1, y: 0 } }}>
          <CourseClassesSection />
        </motion.div>

        <motion.div variants={{ hidden: { opacity: 0, y: 40 }, visible: { opacity: 1, y: 0 } }}>
          <StepsSection />
        </motion.div>

        <motion.div variants={{ hidden: { opacity: 0, y: 40 }, visible: { opacity: 1, y: 0 } }}>
          <OffersStories />
        </motion.div>

        <motion.div variants={{ hidden: { opacity: 0, y: 40 }, visible: { opacity: 1, y: 0 } }}>
          <OffersFreeTrial />
        </motion.div>
      </motion.div>

      {/* Popup Animation */}
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: isPopupOpen ? 1 : 0, scale: isPopupOpen ? 1 : 0.8 }}
        transition={{ duration: 0.3 }}
      >
        {isPopupOpen && (
          <Popup isOpen={isPopupOpen} onClose={closePopup}>
            <WebinarFormPopup onClose={closePopup} />
          </Popup>
        )}
      </motion.div>
    </>
  );
}

export default Offers;
